import React, { useState, useRef, useEffect } from 'react';

const AudioPlayer: React.FC = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const handleFirstClick = () => {
      setHasInteracted(true);
      if (audioRef.current) {
        audioRef.current.play()
          .then(() => setIsPlaying(true))
          .catch(console.error);
      }
    };

    // Escuchar el primer clic en la página
    document.addEventListener('click', handleFirstClick, { once: true });
    document.addEventListener('touchstart', handleFirstClick, { once: true });

    return () => {
      document.removeEventListener('click', handleFirstClick);
      document.removeEventListener('touchstart', handleFirstClick);
    };
  }, []);

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play()
          .then(() => setIsPlaying(true))
          .catch(console.error);
      }
    }
  };

  return (
    <div className="audio-player">
      <audio
        ref={audioRef}
        loop
        preload="auto"
        onEnded={() => setIsPlaying(false)}
        onPause={() => setIsPlaying(false)}
        onPlay={() => setIsPlaying(true)}
      >
        <source src="/audio/background-music.mp3" type="audio/mpeg" />
        Tu navegador no soporta audio HTML5.
      </audio>
      
      <button 
        className="music-toggle"
        onClick={togglePlay}
        aria-label={isPlaying ? "Pausar música" : "Reproducir música"}
      >
        <div className="music-icon">
          {isPlaying ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <rect x="6" y="4" width="4" height="16" rx="1"/>
              <rect x="14" y="4" width="4" height="16" rx="1"/>
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <polygon points="5,3 19,12 5,21"/>
            </svg>
          )}
        </div>
        <div className="music-waves">
          <div className={`wave ${isPlaying ? 'active' : ''}`}></div>
          <div className={`wave ${isPlaying ? 'active' : ''}`}></div>
          <div className={`wave ${isPlaying ? 'active' : ''}`}></div>
        </div>
      </button>
      
      {!hasInteracted && (
        <div className="music-hint">
          <p>Toca la pantalla para escuchar música</p>
        </div>
      )}
    </div>
  );
};

export default AudioPlayer;